var _style, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg2NdOff = function Svg2NdOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 138.8 66.8"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".2nd_off_svg__st4{fill:#e2b128}")), /*#__PURE__*/React.createElement("g", {
    id: "2nd_off_svg___x32_nd_x5F_off",
    fill: "#E2B128"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.3 63.3 118.9-.1c1.1 0 2.2-.4 2.7-1 0 0 8.3-13.2 8.3-13.9V19.6c0-.8-8.3-14.1-8.3-14.1-.5-.7-1.6-1.1-2.7-1.1H4.3z",
    style: {
      fill: "#010101"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 33.8,
    r: 3.9,
    className: "2nd_off_svg__st4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.928 63.194v-58.9h13.9v58.9zM9.958 63.224v-58.9h13.9v58.9z",
    className: "2nd_off_svg__st4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "2nd_off_svg__XMLID_21_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "2nd_off_svg__XMLID_22_",
    d: "M51.6 27.5c-2 0-3.7 1.5-4.4 3.6-.7 1.8-1.7 2.6-1.8 2.7 0 0 1.1.9 1.8 2.7.8 2.1 2.5 3.6 4.4 3.6l.9-.9-.9-.9c-1.5 0-2.7-1.8-3.1-3.5h4.8V36h1.8v-1.3h2c.3.5.9.9 1.5.9 1 0 1.8-.8 1.8-1.8s-.8-1.7-1.7-1.8c-.7 0-1.3.3-1.6.9h-2v-1.3h-1.8v1.3h-4.8c.3-1.8 1.6-3.5 3.1-3.5l.9-.9z",
    style: {
      fill: "#e2b128",
      stroke: "#e1b128",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    }
  }))));
};
export default Svg2NdOff;